import { useRouteError } from 'react-router-dom';

import { GenericButton } from '@shared/components/ui/custom';

import { ErrorState } from './ErrorState';

export const GlobalErrorPage = () => {
  const error = useRouteError() as Error;

  return (
    <ErrorState
      display="Oops!"
      title="Something went wrong"
      description="An unexpected error occurred in the application."
    >
      {/* Dev-only error details */}
      {import.meta.env.DEV && error && (
        <div className="mt-6 w-full max-w-2xl rounded-md bg-muted/30 p-4 text-left border border-error-border/20 overflow-auto">
          <p className="text-sm font-semibold text-error-foreground">Dev Error Details:</p>
          <pre className="mt-2 text-xs text-error-foreground/80 whitespace-pre-wrap">
            {error.message || 'Unknown error'}
          </pre>
        </div>
      )}

      <div className="mt-10 flex items-center justify-center gap-4">
        <GenericButton onClick={() => globalThis.location.reload()} variant="default" label="Reload Page" />
        <GenericButton onClick={() => globalThis.location.assign('/')} variant="outline" label="Go to Home" />
      </div>
    </ErrorState>
  );
};
